import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { CannotContainOnlySpaceValidator } from 'src/app/directives/cannot-contain-only-space-validator.directive';

export const simplicateModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'md',
  backdrop: 'static'
};

@Component({
  selector: 'app-simplicate-modal',
  templateUrl: './simplicate-modal.component.html'
})
export class SimplicateModal implements OnInit {
  public SimplicateUrl: string = PKIUrls.SimplicateUrl;
  @Output('updateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  @Input('organisationSettings') set organisationSettings(val: any){
    this.simplicateKey = (val.SimplicateApiKey == undefined || val.SimplicateApiKey == "" || val.SimplicateApiKey == "false") ? "" : val.SimplicateApiKey;
    this.simplicateSecret = (val.SimplicateApiSecret == undefined || val.SimplicateApiSecret == "" || val.SimplicateApiSecret == "false") ? "" : val.SimplicateApiSecret;
    this.simplicateSubdomain = (val.SimplicateApiSubdomain == undefined || val.SimplicateApiSubdomain == "" || val.SimplicateApiSubdomain == "false") ? "" : val.SimplicateApiSubdomain;
    this._organisationSettings = val;
  }
  get organisationSettings(): any {
    return this._organisationSettings;
  }
  private _organisationSettings!: any;
  simplicateKey: string = "";
  simplicateSecret: string = "";
  simplicateSubdomain: string = "";
  form!: UntypedFormGroup;
  
  constructor(private formBuilder: UntypedFormBuilder, private activeModal: NgbActiveModal) { 
    this.form = this.formBuilder.group({
      simplicateKey: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()]),
      simplicateSecret: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()]),
      simplicateSubdomain: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()])
    });
  }

  ngOnInit(): void {
  }

  save(){
    let settings: any[] = [];

    let apiKey = (document.getElementById('SimplicateApiKey') as HTMLInputElement).value;
    settings.push({key: 'SimplicateApiKey', value: apiKey});

    let apiSecret = (document.getElementById('SimplicateApiSecret') as HTMLInputElement).value;
    settings.push({key: 'SimplicateApiSecret', value: apiSecret});

    let apiSubdomain = (document.getElementById('SimplicateApiSubdomain') as HTMLInputElement).value;
    settings.push({key: 'SimplicateApiSubdomain', value: apiSubdomain});

    this.updateOrganisationSettings.emit(settings);
  }

  closeDialog() {
    this.activeModal.close(false);
  }
}
